import { t } from "@travily/i18n";
import { Heading } from "@ui/components/Heading";
import { Switch } from "@ui/components/Switch";

export interface NotificationCategory {
  enabled: boolean;
  key: string;
}

export interface NotificationGroup {
  categories: NotificationCategory[];
  key: string;
}

export interface NotificationsSettingsViewProps {
  groups: NotificationGroup[];
  onToggle: (category: string, enabled: boolean) => void;
}

// i18n-tasks-use t('web.accounts.settings.notifications.groups.activity.title')
// i18n-tasks-use t('web.accounts.settings.notifications.groups.activity.description')
// i18n-tasks-use t('web.accounts.settings.notifications.groups.milestones.title')
// i18n-tasks-use t('web.accounts.settings.notifications.groups.milestones.description')
// i18n-tasks-use t('web.accounts.settings.notifications.categories.messages.title')
// i18n-tasks-use t('web.accounts.settings.notifications.categories.messages.description')
// i18n-tasks-use t('web.accounts.settings.notifications.categories.community.title')
// i18n-tasks-use t('web.accounts.settings.notifications.categories.community.description')
// i18n-tasks-use t('web.accounts.settings.notifications.categories.badges.title')
// i18n-tasks-use t('web.accounts.settings.notifications.categories.badges.description')
const groupCopy = (key: string, part: "title" | "description") =>
  t(`web.accounts.settings.notifications.groups.${key}.${part}`);
const categoryCopy = (key: string, part: "title" | "description") =>
  t(`web.accounts.settings.notifications.categories.${key}.${part}`);

export function NotificationsSettingsView({ groups, onToggle }: NotificationsSettingsViewProps) {
  const sections = groups.map((group) => ({
    key: group.key,
    title: groupCopy(group.key, "title"),
    description: groupCopy(group.key, "description"),
    rows: group.categories.map((category) => ({
      ...category,
      title: categoryCopy(category.key, "title"),
      description: categoryCopy(category.key, "description"),
    })),
  }));

  return (
    <div>
      <Heading.Root color="primary" size="lg" weight="bold">
        <Heading.Title as="h1">{t("web.accounts.settings.sections.notifications")}</Heading.Title>
      </Heading.Root>

      {sections.map((section) => (
        <section className="mt-8 first:mt-6" key={section.key}>
          <h2 className="font-bold text-neutral-900 text-xl leading-7">{section.title}</h2>
          <p className="mt-1 text-base text-neutral-600 leading-6">{section.description}</p>

          <div className="mt-5 flex flex-col gap-5">
            {section.rows.map((row) => (
              <Switch
                description={row.description}
                isSelected={row.enabled}
                key={row.key}
                label={row.title}
                layout="row"
                onChange={(enabled) => onToggle(row.key, enabled)}
              />
            ))}
          </div>
        </section>
      ))}
    </div>
  );
}
